<template>
    <div class="shows-wrapper">
        <div class="grid-100 grid-parent"></div>
        <h1 class="main-title individual grid-container">Shows</h1>
        <!-- <div class="mobile-navigation shows layer3"></div> -->
        <div class="grid-100 grid-parent layer2">
            <div class=" grid-container">
                <div class="grid-45 grid-parent">
                    <div
                      class="video-item grid-100 grid-parent"
                      v-for="video in embeddedVideos"
                      :key="video.video_link"
                      v-if="video.video_link"
                    >
                      <div class="video-header shows grid-100 grid-parent">
                          <div class="video">
                            <iframe width="560" height="315" :src="'https://www.youtube.com/embed/'+video.video_link" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/BhwZPV2Y2V4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                          </div>
                      </div>
                    </div>
                </div>
                <div class="tour-dates grid-50 push-5">
                   <Loader :active="!showsLoaded"></Loader>
                   <div v-if="tour.shows && tour.shows.length" class="tour-group-wrapper" v-bind:class="{ open: tour.open, close: !tour.open }" v-for="(tour,indexTour) in tours" :key="indexTour">
                        <h4 class="tour-name" v-bind:class="{ open: tour.open, close: !tour.open }" v-on:click="openTour(tour,indexTour)" v-html="tour.title.rendered"></h4>
                          <div class="tour-wrapper" v-bind:class="{ open: tour.open, close: !tour.open }" >
                            <div class="shows-month-wrapper" v-for="(showMonth, index) in tour.shows" v-if="showMonth" :key="index">
                              <h4 class="month">{{showMonth[0].date_display_date}}</h4>
                              <ul class="tour-list">
                                  <li v-for="(show, index) in showMonth" class="tour-event grid-100 grid-parent" :key="index">
                                      <span class="date">{{getDateInFormat(show.show_date)}}</span>
                                      <span class="location">{{show.place}} </span>
                                      <span v-show="!isDatePast(show.show_date)">
                                      <a class="buy layer1" v-bind:href="show.tickets_link" target="_blank"><span
                                              class="tour-cta">Buy Tickets </span></a>
                                      <a class="buy layer1" v-bind:href="show.tickets_link" target="_blank"><span
                                              class="tour-cta-mobile">Buy </span></a>
                                      </span>
                                  </li>
                              </ul>
                            </div>
                          </div>
                    </div>
                    <span class="no-shows" v-show="(showsLoaded && tours.length === 0)">Sorry, there are no dates available</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  import axios from 'axios'
  import { apiRequest } from '../services';
  import { API_BASE } from '@/config'
  import Loader from './Loader'

  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]

  export default {
    name: 'test',
    data () {
      return {
        shows: [],
        tours: [],
        showsLoaded: false,
        embeddedVideos: [],
      }
    },
    components: {
      Loader
    },
    mounted () {
      window.scrollTo(0, 0);
      /**
       * Get the data for the embedded featured videos
       *
       * @returns { Promise } resolves to an array of
       * embedded videos
       */
      apiRequest("featured_show_video")
        .then(this.receivedVideoEmbedData)
        .catch(this.videoEmbedDataFailed);

      axios.get(`${API_BASE}/wp/wp-json/wp/v2/show_tours`,  {
		mode: 'no-cors',
	}).then((response) => {
        this.tours = response.data.map(tour => {
          var open = false;
          if (this.$route.params.tour !== undefined && tour.slug === this.$route.params.tour) {
            open= true;
          }
          const mutatedTour = Object.assign({}, tour, { open: open });
          return mutatedTour;
        })

        for (var i = 0; i < this.tours.length; i++) {
          let orderedShows = {}
          for (var j = 0; j < this.tours[i].shows.length; j++) {
            // // Process the dates and array keys

            let dateObject = new Date()
            dateObject.setFullYear(parseInt(this.tours[i].shows[j].show_date.substring(0, 4)), parseInt(this.tours[i].shows[j].show_date.substring(5, 7) - 1), parseInt(this.tours[i].shows[j].show_date.substring(8, 10)))
            let monthShow = dateObject.getMonth() + 1
            let yearShow = dateObject.getFullYear()
            let arrayKey = new Date(yearShow, monthShow - 1, 1)

            // If array key doesn't exist, create it
            if (!orderedShows[arrayKey.getTime()]) {
              orderedShows[arrayKey.getTime()] = []
            }
            // Set the display title of the section
            this.tours[i].shows[j]['date_display_date'] = monthNames[dateObject.getMonth()] + ' ' + dateObject.getFullYear()
            // Add show to month section
            orderedShows[arrayKey.getTime()].push(this.tours[i].shows[j])
            orderedShows[arrayKey.getTime()].sort(compare)
          }

            this.tours[i].shows = sortArray(orderedShows);
        }
        this.tours.sort(compareTour)

        this.showsLoaded = true;
        if (this.$route.query.tour) {
            for (i = 0; i < this.tours.length; i++) {
              if (this.tours[i].slug === this.$route.query.tour) {
                this.tours[i].open = true;
              }
            }
        }
      })
    },
    methods: {
      getDateInFormat (date) {
        var d = new Date()
        d.setFullYear(parseInt(date.substring(0, 4)), parseInt(date.substring(5, 7) - 1), parseInt(date.substring(8, 10)))
        // var test = date.substring(6, 10) + date.substring(0, 2) + date.substring(3, 5)
        var day = date.substring(8, 10)
        // var month = date.substring(0, 2)
        // var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        var weekdayNames = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
        var dayFormat
        switch (parseInt(day)) {
          case 1:
          case 21:
          case 31:
            dayFormat = 'st'
            break
          case 2:
          case 22:
            dayFormat = 'nd'
            break
          case 3:
          case 23:
            dayFormat = 'rd'
            break
          default:
            dayFormat = 'th'
            break
        }
        return weekdayNames[parseInt(d.getDay())] + ' ' + parseInt(day) + dayFormat + ' '  //  d.getDate() + dayFormat + ' ' + monthNames[d.getMonth()]
      },
      getMonthName (monthNumber) {
        let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        return monthNames[parseInt(monthNumber - 1)]
      },
      isDatePast (date) {
        return isDatePast(date)
      },
      openTour (tour, index) {
        tour.open = !tour.open;
        for (var i = 0; i < this.tours.length; i++) {
          if (i !== index) {
            this.tours[i].open = false;
          }
        }
        window.scrollTo(0, 0)
      },
      receivedVideoEmbedData(data) {
        this.embeddedVideos = data;
      },
      videoEmbedDataFailed(error) {
        console.log("There was an error: ", error);
      },
    }
  }

  function isDatePast (date) {
    const today = new Date();
    today.setDate(today.getDate() - 1)
    const d = new Date()
    d.setFullYear(parseInt(date.substring(0, 4)), parseInt(date.substring(5, 7) - 1), parseInt(date.substring(8, 10)))
    return today >= d
  }

  function sortArray (orderedShows) {
    let keys = []
    let len
    let outputArray = []
    for (var tmpk in orderedShows) {
      if (orderedShows.hasOwnProperty(tmpk)) {
        keys.push(tmpk)
      }
    }
    keys.sort()
    len = keys.length
    for (var tmpi = 0; tmpi < len; tmpi++) {
      let k = keys[tmpi]
      outputArray.push(orderedShows[k])
    }

    return outputArray
  }

  function compare (a, b) {
    let aData = new Date(a.show_date)
    aData.setFullYear(parseInt(a.show_date.substring(0, 4)), parseInt(a.show_date.substring(5, 7) - 1), parseInt(a.show_date.substring(8, 10)))
    let bData = new Date(b.show_date)
    bData.setFullYear(parseInt(b.show_date.substring(0, 4)), parseInt(b.show_date.substring(5, 7) - 1), parseInt(b.show_date.substring(8, 10)))
    if (aData.getTime() < bData.getTime()) {
      return -1
    }
    if (aData.getTime() > bData.getTime()) {
      return 1
    }
    return 0
  }

  function compareTour (a, b) {
    let aData = new Date(a.start_of_tour_date)
    aData.setFullYear(parseInt(a.start_of_tour_date.substring(0, 4)), parseInt(a.start_of_tour_date.substring(5, 7) - 1), parseInt(a.start_of_tour_date.substring(8, 10)))
    let bData = new Date(b.start_of_tour_date)
    bData.setFullYear(parseInt(b.start_of_tour_date.substring(0, 4)), parseInt(b.start_of_tour_date.substring(5, 7) - 1), parseInt(b.start_of_tour_date.substring(8, 10)))
    if (aData.getTime() < bData.getTime()) {
      return -1
    }
    if (aData.getTime() > bData.getTime()) {
      return 1
    }
    return 0
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

</style>



// WEBPACK FOOTER //
// Shows.vue?30ba923b